"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Ord_1 = require("fp-ts/lib/Ord");
const js_joda_1 = require("js-joda");
require("js-joda-timezone");
const Either_1 = require("fp-ts/lib/Either");
const format_1 = require("./format");
const localdate_1 = require("./localdate");
class DateTime {
    constructor(i) {
        this.i = i;
        this.format = (fmt = 'fi') => js_joda_1.ZonedDateTime.ofInstant(this.i, format_1.hki).format(format_1.dateTimeFormatterOf(fmt));
        this.toLocalDate = () => new localdate_1.LocalDate(js_joda_1.LocalDate.ofInstant(this.i, format_1.hki));
        this.plusDays = (toAdd) => new DateTime(this.i.plusSeconds(24 * 60 * 60 * toAdd));
        this.plusYears = (toAdd) => new DateTime(js_joda_1.ZonedDateTime.now(format_1.hki).plusYears(toAdd).toInstant());
        this.isAfter = (x) => this.i.isAfter(x.i);
        this.isWithInRange = (start, end) => this.i.plusMillis(1).isAfter(start.i) && this.i.minusMillis(1).isBefore(end.i);
        this.startOfYear = () => new DateTime(format_1.startOfYearZdt(this.i).toInstant());
        this.endOfYear = () => new DateTime(format_1.startOfYearZdt(this.i)
            .plusYears(1)
            .minusSeconds(1)
            .toInstant());
        this.toDate = () => new Date(this.i.toEpochMilli());
    }
}
DateTime.fromDate = (d) => new DateTime(js_joda_1.Instant.ofEpochMilli(d.getTime()));
DateTime.parse = (x) => Either_1.tryCatch(() => new DateTime(js_joda_1.Instant.parse(x)), () => x);
DateTime.ordDesc = Ord_1.fromCompare((a, b) => a.i.isBefore(b.i) ? 1 : a.i.isAfter(b.i) ? -1 : 0);
DateTime.ordAsc = Ord_1.fromCompare((a, b) => b.i.isBefore(a.i) ? 1 : b.i.isAfter(a.i) ? -1 : 0);
DateTime.from = ({ d }, { t }) => new DateTime(js_joda_1.LocalDateTime.of(d.year(), d.month(), d.dayOfMonth(), t.hour(), t.minute())
    .atZone(format_1.hki)
    .toInstant());
exports.DateTime = DateTime;
exports.now = () => new DateTime(js_joda_1.Instant.now(js_joda_1.Clock.system(format_1.hki)));
